<div class="md-dialog-container">
<h1 mat-dialog-title>{{data.titel}}</h1>
<mat-dialog-content>
  <p>{{data.text}}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <br><br><br><br>
  <button mat-button class="btn btn-info" (click)="closeDialog();">OK</button>
</mat-dialog-actions>

</div>
